/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_AboutInputs */

const en_footer_about = /** @type {(inputs: Footer_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About`)
};

const ko_footer_about = /** @type {(inputs: Footer_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`소개`)
};

const ja_footer_about = /** @type {(inputs: Footer_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`概要`)
};

/**
* | output |
* | --- |
* | "About" |
*
* @param {Footer_AboutInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const footer_about = /** @type {((inputs?: Footer_AboutInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_AboutInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_about(inputs)
	if (locale === "ko") return ko_footer_about(inputs)
	return ja_footer_about(inputs)
});